const FEATURE_FLAGS_FOR_TESTS = {
  requiredFeatureFlag: 'requiredFeatureFlag',
  someFeatureFlag: 'someFeatureFlag',
}

export const FEATURES = {
  PRICES: 'prices',
  ...FEATURE_FLAGS_FOR_TESTS,
}
